import { default as place } from './place/routes'
import { default as panel } from './panel/routes'

export default [
    ...place,
    ...panel,
    {
        path: '/ambiences',
        name: 'ambiences',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Ambientes',
            icon: 'mdi-flask-outline',
            breadcrumbs: [
                { text: 'Ambientes', disabled: true, href: '/' }
            ],
        }
    },
    {
        path: '/ambiences/catalog',
        name: 'ambiences-catalog',
        component: () => import ('./pages/Catalog'),
        meta: {
            title: 'Catálogo de Ambientes',
            icon: 'mdi-view-grid-outline',
            breadcrumbs: [
                { text: 'Ambientes', disabled: false, href: '/ambiences' },
                { text: 'Catálogo', disabled: true, href: '/' }
            ],
        }
    },
    {
        path: '/ambiences/map/:id',
        name: 'ambiences-map',
        component: () => import('./pages/Map'),
        meta: {
            title: 'Mapa de Ambiente',
            icon: 'mdi-map-search-outline',
            breadcrumbs: [
                { text: 'Ambientes', disabled: false, href: '/ambiences' },
                { text: 'Mapa de Ambiente', disabled: true },
            ],
        },
    },
]